<template>
<el-dialog width="400px" title="用户密码重置" append-to-body :visible.sync="dialogFormVisible">
  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="密码" prop="pass">
      <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
      <div class="el-form-item__tip">建议不少于8位，由大小写字母、数字和特殊字符组成。</div>
    </el-form-item>
    <el-form-item label="确认密码" prop="checkPass">
      <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveData">确 定</el-button>
  </div>
</el-dialog>
</template>

<script>
export default {
  data () {
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      loading: false,
      dialogFormVisible: false,
      ruleForm: {
          pass: '',
          checkPass: '',
        },
      rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
      }
    }
  },
  watch: {
    dialogFormVisible () {
      this.ruleForm.pass = '';
      this.ruleForm.pass = ''
    }
  },
  created () {
    
  },
  methods: {
    /**
      * 保存或更新
      */
    saveData () {
      const vm = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var postData = {
            newPasswd: this.ruleForm.checkPass
          }
          this.$http.post('/user/modifyPasswd', postData).then(function (response) {
            if(response.data.header.code == 'A1000'){
              vm.dialogFormVisible = false;
              vm.$message.success(response.data.header.msg);
              vm.$emit('change')
            }else{
              vm.$message.warning(response.data.header.msg)
            }
          })
          .catch(function (error) {
            vm.$message.error('网络错误')
          });
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped type="text/css">
.el-form-item__tip {
  font-size: 12px;
  color: #c51111;
  line-height: 1.5;
  margin-top: 4px;
}
</style>